import {setClick, getTarget, sleep} from '@/canv/utils.js';

export class infoWindow {

    constructor() {}


    async open(text) {

        let infoW = document.getElementsByClassName("infoWindow")[0];
        if (infoW != undefined) {
            return;
        }

        var infoWindow = document.createElement('div');
        infoWindow.classList.add("infoWindow");
        document.body.prepend(infoWindow);

        infoWindow.innerHTML = text;
        clearTimeout(this.timer);
        this.timer = setTimeout(async function() {
            let infoWindow = document.getElementsByClassName("infoWindow")[0];
            if (infoWindow != undefined) {
                infoWindow.style.opacity = 0;
                await sleep(1000);
                infoWindow.outerHTML = "";
            }
        }, 1000);
    }

    init() {

        setClick("accessMenuWrapper", this.wrapperClick.bind(this));
        
        let markOptions = document.getElementsByClassName("accessMenuItem");
        for (var i = 0; i < markOptions.length; i++) {
            markOptions[i].addEventListener('mousedown', this.optionClick.bind(this), false);
        }

    }

    alignMenu() {
        var markTarget = this.data["toggle"];
        var menu = document.getElementsByClassName("accessMenu")[0];
        var markTargetSize = markTarget.getBoundingClientRect();
        menu.style.left = (markTargetSize.right - markTargetSize.width).toString() + "px";
        menu.style.top = (markTargetSize.top + markTargetSize.height).toString() + "px";
    }

    close() {
        var markWrapper = document.getElementsByClassName("accessMenuWrapper")[0];
        if (markWrapper != undefined) {
            markWrapper.outerHTML = "";
        }
    }



    /* Templates */

    getMenu() {

        let items = ``;
        for (var i = 0; i < this.data["items"].length; i++) {
            items += this.applyItemTemplate(this.data["items"][i]["name"], i);
        }
        var template = `
            <div class="accessMenu">
                ` + items + `
            </div>
        `;

        return template;
    }

    applyItemTemplate(name, index) {
        return `
            <div class="accessMenuItem" optionIndex=` + index + `>
                <div class="accessMenuItemTitle">` + name + `</div>
            </div>
        `;
    }

    /* Proccessors */

    wrapperClick(e) {
        var tryInner = getTarget(e, "accessMenu");
        if (tryInner == null) {
            this.close();
        }
    }

    async optionClick(e) {

        var item = getTarget(e, "accessMenuItem");
        var optionIndex = parseInt(item.getAttribute("optionIndex"));

        if (this.data["items"][optionIndex]["toSet"]) {
            let toggleTitle = this.data["toggle"].querySelector(".unionAccessToggleName");
            if (toggleTitle != undefined) {
                toggleTitle.innerHTML = this.data["items"][optionIndex]["name"];
            }
        }

        this.close();

        this.data["proccessor"](this.data, this.data["items"][optionIndex]);
    }

}